// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"b864de63","137":"9339355e","199":"5429bf10","672":"3eb105a4","893":"4a167461","925":"795496d4"}[chunkId] + ".chunk.css";
};